import { SofaOutlineIcon } from './SofaOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 37B31F21-3190-4E2D-A824-C5CC4FF66493
 * name sofa-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sofa-outline.svg
 * tags
 * - Home Automation 
 */
export const CouchOutlineIcon = SofaOutlineIcon;
export default CouchOutlineIcon